import { Box, CheckBox, Image, ModBox, Text } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { useState } from 'react'
import sort_decreasing from '../../assets/images/Decreasing.png'
import sort_increasing from '../../assets/images/Increasing.png'
import sort_inactive from '../../assets/images/sort_inactive.png'

const getSortImage = (direction: string) => {
  const getImage: any = {
    DESC: sort_decreasing,
    ASC: sort_increasing,
    NONE: sort_inactive,
  }
  return getImage[direction] ?? getImage.NONE
}

const CustomHeaderRenderer = ({
  label,
  styles,
  sortBy,
  sortDirection = 'ASC',
  isColumnSearchEnabled,
  onSearchTextChange,
  headerRowKeys,
  getIsAllSelected,
  showHeaderCheckBox = true,
}: any) => {
  const showSortIndicator = sortBy === label

  const handleColumnSearch = (searchText: string) => {
    if (onSearchTextChange) {
      onSearchTextChange(label, searchText)
    }
  }
  const [isAllChecked, setAllChecked] = useState(false)
  const handleAllCheckedChange = (isChecked: string) => {
    setAllChecked(isChecked === 'true')
    getIsAllSelected && getIsAllSelected(isChecked === 'true')
  }
  return (
    <Box flexDirection={'column'} flex={1}>
      <Box {...styles.titleheaderView}>
        <Text {...styles.titleHeader}>{headerRowKeys[label] ?? label}</Text>
        {showSortIndicator && (
          <Box paddingLeft={4}>
            <Image source={getSortImage(sortDirection)} width={16} height={16} />
          </Box>
        )}
      </Box>
      {isColumnSearchEnabled && label !== 'check' && (
        <TextInput
          placeholderTextColor={'BLACK'}
          onChangeText={handleColumnSearch}
          fontSize={12}
          fontWeight={'300'}
          fontFamily={'jiotype-medium'}
        />
      )}
      <ModBox show={label === 'check' && showHeaderCheckBox}>
        <CheckBox onChange={handleAllCheckedChange} checked={isAllChecked} iconSize={24} color={'PRIMARY'} />
      </ModBox>
    </Box>
  )
}

export { CustomHeaderRenderer }
